import { render } from "./About.vue?vue&type=template&id=f77227a2&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"

import "./About.vue?vue&type=style&index=0&id=f77227a2&lang=scss&scoped=true"

import exportComponent from "D:\\Project\\oversea-website\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f77227a2"]])

export default __exports__